/**
 * Contract Manufacturing Type options for Contract Manufacturer profile (Factory Details).
 * Single-select dropdown options.
 */
export const CONTRACT_MANUFACTURING_TYPE_OPTIONS = [
  'White label Manufacturers',
  'Private label Manufacturers',
  'Contract Manufacturers',
  'OEM Manufacturers (Original Equipment Manufacturer)',
  'ODM Manufacturers (Original Design Manufacturer)',
  'OBM Manufacturers (Original Brand Manufacturer)',
];

/** Dropdown map: array of { value, label } */
export const CONTRACT_MANUFACTURING_TYPE_MAP = CONTRACT_MANUFACTURING_TYPE_OPTIONS.map((label) => ({
  value: label,
  label,
}));

export default CONTRACT_MANUFACTURING_TYPE_OPTIONS;
